import React from 'react';
import PropTypes from 'prop-types';

import Confirm from 'components/Confirm';
import Message from 'components/Message';
import { bem } from 'helpers/class-name';

import './SkuVenueClosedConfirmationModal.scss';
import messages from './SkuVenueClosedConfirmationModal.messages';

const { block, element } = bem('sku-venue-closed-confirmation-modal');

export const SKU_VENUE_CLOSED_CONFIRMATION_MODAL_NAME = 'SkuVenueClosedConfirmationModal';

const SkuVenueClosedConfirmationModal = ({ handleCancel, handleConfirm }) => {
  return (
    <Confirm
      title={<Message message={messages.title} />}
      cancelNode={<Message message={messages.cancel} />}
      acceptNode={<Message message={messages.confirm} />}
      hasCloseButton
      hideButtonBorder
      size="large"
      onConfirm={handleConfirm}
      onRequestClose={handleCancel}>
      {({ title, buttons }) => {
        return (
          <div className={block()}>
            {title}
            <div className={element('description-container')}>
              <Message message={messages.description} />
            </div>
            {buttons}
          </div>
        );
      }}
    </Confirm>
  );
};

SkuVenueClosedConfirmationModal.propTypes = {
  handleCancel: PropTypes.func,
  handleConfirm: PropTypes.func,
};

export default SkuVenueClosedConfirmationModal;
